module.exports = __webpack_public_path__ + "assets/img/KeyReport_004.20b36383-ps.jpg";